// Reference: <https://www.w3schools.com/howto/howto_css_hide_scrollbars.asp>
export const hideScrollbarCss = {
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  '-ms-overflow-style': 'none',
  scrollbarWidth: null,
}
